(function() {
	'use strict';

	angular
		.module('app.setup')
		.controller('leanSyncFileUpload', leanSyncFileUpload);

	leanSyncFileUpload.$inject = ['$rootScope', '$scope', '$window', '$timeout', '$uibModal', 'leanSyncConfigService', 'storeService'];

	function leanSyncFileUpload($rootScope, $scope, $window, $timeout, $uibModal, leanSyncConfigService, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var uploadTypeMessage = {
			'LeanTransform' : 'Lean transform',
			'LeanLoad' : 'Lean Load',
			'LeanSync' : 'Lean sync',
			'LeanTransformGlobal' : 'Lean transform global',
			'LeanTransformStatic' : 'Lean transform static',
			'LeanTransformPrevious' : 'Lean transform previous'
		};
		vm.uploadTypes = [
			{id: 'LeanTransform', text: 'Lean Transform'},
			{id: 'LeanLoad', text: 'Lean Load'},
			{id: 'LeanSync', text: 'Lean Sync'},
			{id: 'LeanTransformGlobal', text: 'Lean Transform Global'},
			{id: 'LeanTransformStatic', text: 'Lean Transform Static'},
			{id: 'LeanTransformPrevious', text: 'Lean Transform Previous'}
		];
		vm.uploadFile = uploadFile;
		vm.onSelectedUploadType = onSelectedUploadType;
		var defaultUploadTypes = '.zip,.tar.gz';
		var defaultAllowedUploadTypesMessage = 'zip and tar.gz';
		vm.allowedUploadType = defaultUploadTypes;
		vm.allowedUploadTypesMessage = defaultAllowedUploadTypesMessage;
		vm.upload = {};
		vm.env = window.globalConfig.environment;

		if ($rootScope.authz.isLeanDNAAdmin(adminConfig.factory.id)) {
			vm.upload.uploadType = 'LeanTransform';
		} else {
			$window.location.href = $window.location.protocol + '//' + $window.location.host + '/application/f/home.html#/unauthorized';
		}

		function uploadFile() {
			var confirmScope = $scope.$new();
			confirmScope.fileName = vm.upload.file.name;
			confirmScope.env = vm.env;
			confirmScope.fileUploadType = vm.upload.uploadType;
			confirmScope.customerName = adminConfig.customer.name;
			confirmScope.siteName = adminConfig.factory.name;
			confirmScope.siteId = adminConfig.factory.id;

			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/setup/leansync/leansync_file_upload_confirmation.html'
			};

			confirmScope.uploadFile = function () {
				confirmScope.closeDialog();
				leanSyncConfigService.uploadLeanSyncFile(vm.upload, uploadTypeMessage[vm.upload.uploadType], adminConfig.factory.id).then(function(message){
					if (message === 'Lean Sync File Uploaded Successfully') {
						vm.upload.uploadType = 'LeanTransform';
						vm.upload.file = null;
					}
				});
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function () {
				instance.close();
				confirmScope.$destroy();
			};
		}

		function onSelectedUploadType(selectedItem) {
			if (vm.upload.uploadType == 'LeanTransformStatic') {
				vm.allowedUploadType = '.zip';
				vm.allowedUploadTypesMessage = 'zip';
			} else if (vm.upload.uploadType == 'LeanTransformPrevious') {
				vm.allowedUploadType = '.tar.gz';
				vm.allowedUploadTypesMessage = '.tar.gz';
			} else {
				vm.allowedUploadType = defaultUploadTypes;
				vm.allowedUploadTypesMessage = defaultAllowedUploadTypesMessage;
			}
		}
	}
})();
